export default __webpack_public_path__ + "static/media/ny-cityguide-01.be3165e9.jpg";